import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatTabChangeEvent, MatTabGroup, MatTab, MatTabLabel } from '@angular/material/tabs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { combineLatest, Subscription } from 'rxjs';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ConsultaSiniestroOutput } from 'src/app/models/complementos-web/complementos-web.model';
import { CoberturaProcesada, ConsultaComplementoGeneralOutput, ConsultaRecuperacionesPagosOutput } from '../../../../models/complementos-web/complementos-web.model';
import moment from 'moment';
import { MatTableDataSource } from '@angular/material/table';
import { SiniestroCompleState } from '../../@store/complemento-web/complemento-web.models';
import { CrearActualizarPagosRecuperacionesComponent } from '../../@components/crear-actualizar-pagos-recuperaciones/crear-actualizar-pagos-recuperaciones.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgFor, NgSwitch } from '@angular/common';

@Component({
    selector: 'app-seccion-pagos-recuperaciones',
    templateUrl: './seccion-pagos-recuperaciones.component.html',
    styleUrls: ['./seccion-pagos-recuperaciones.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTabGroup, NgFor, MatTab, MatTabLabel, NgSwitch, CrearActualizarPagosRecuperacionesComponent]
})
export class SeccionPagosRecuperacionesComponent implements OnInit, OnDestroy {

  @ViewChildren(CrearActualizarPagosRecuperacionesComponent) refPagosRecup : CrearActualizarPagosRecuperacionesComponent;

  public tabIndex: number = 0;
  public detalleSiniestro: SiniestroCompleState;
  public siniestroBase: string;
  public detalleSeccionComplemento: ConsultaComplementoGeneralOutput;
  public detalleSeccionSiniestroComplemento: ConsultaSiniestroOutput;
  public recupPagosSiniestro: ConsultaRecuperacionesPagosOutput;
  public listaPagosRecuperaciones = new MatTableDataSource([]);
  public listaObservables = new Subscription();

  public catTabsPagosRecuperaciones = [
    { id: 1, nombre: 'Pagos' },
    { id: 2, nombre: 'Recuperaciones' },
  ];

  constructor(
    public dialogRef: MatDialogRef<SeccionPagosRecuperacionesComponent>,
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    private procesosComunesService: ProcesosComunesComplementoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.obtenerReduxState();
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.listaObservables.unsubscribe();
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      this.siniestroBase = siniestro;
      this.detalleSiniestro = detalleSiniestro;
      this.detalleSeccionSiniestroComplemento = detalleSiniestro?.siniestroDetalle;
      this.consultarComplementoWeb(this.siniestroBase);
      this.tabIndex = Number(this.detalleSiniestro.responsabilidad == 1 ? 0 : 1);
    });
    this.listaObservables.add(subsComplemento);
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close();
  }

  onTabChange(event: MatTabChangeEvent) {
    this.tabIndex = Number(event.index + 1);
    this.consultarComplementoWeb(this.siniestroBase);
  }

  consultarPagosRecuperaciones(siniestro: string) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoCliente: this.detalleSiniestro.responsabilidad,
    }
    console.log(request)
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaRecuperacionesPagos(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.recupPagosSiniestro = value.Resultado;
        const responsableSiniestro = this.detalleSiniestro.responsabilidad;
        const responsableActual = this.detalleSeccionComplemento.Responsable;
        if (this.recupPagosSiniestro.RecuperacionPago.length && responsableSiniestro != responsableActual) {
          return this.validaEliminaRecuperacionesPagos();
        } else if (this.recupPagosSiniestro.RecuperacionPago.length && responsableSiniestro == responsableActual) {
          // this.actualizarComplemento();
          this.recupPagosSiniestro = value.Resultado;
          this.listaPagosRecuperaciones = new MatTableDataSource(this.recupPagosSiniestro.RecuperacionPago ?? []);
        } else {
          this.recupPagosSiniestro = value.Resultado;
          this.listaPagosRecuperaciones = new MatTableDataSource(this.recupPagosSiniestro.RecuperacionPago ?? []);

        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de las reglas de ajuste.' }));
      },
    })


  }

  validaEliminaRecuperacionesPagos(): void {
    const responsableSiniestro = this.detalleSiniestro.responsabilidad;
    const responsableActual = this.detalleSeccionComplemento.Responsable;
    const recuperacionPago = responsableSiniestro == 1 ? 'pago(s)' : 'recuperación(es)';
    const tipo = responsableSiniestro !== responsableActual
      ? (responsableSiniestro === 1 ? 'pago(s)' : 'recuperación(es)')
      : recuperacionPago;

    const mensajeHtml = `
          <p>Se modificó el campo de <b>"Responsable"</b> y contiene registro(s) de <b>${tipo}</b> asociados.</p>
          <p>Para continuar deberá eliminar dichos registros.</p>
        `;

    this.procesosComunesService.alertaGeneralComplemento('Aviso', '', 'warning', true, false, mensajeHtml).then(result => {
      this.closeDialog('Cancelar');
    });
  }

  actualizarComplemento() {
    //TODO VALIDACION DE LA SERIE
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.siniestroBase);
    const perfilAdministrador = this.detalleSiniestro?.perfilAdministrador;
    let serieNormal = ((this.detalleSeccionSiniestroComplemento.Siniestro[0].serie_normal == null) ? 0 : this.detalleSeccionSiniestroComplemento.Siniestro[0].serie_normal);
    let coberturas = this.procesaCoberturas();
    let fechaDefault = "01/01/1901";
    let horaDefault = "00:00:00";

    const request = {
      sucursal: this.detalleSeccionSiniestroComplemento.Siniestro[0].sucursalk1,
      linea: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_linea,
      producto: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_prod,
      poliza: this.detalleSeccionSiniestroComplemento.Siniestro[0].polizak1,
      endoso: this.detalleSeccionSiniestroComplemento.Siniestro[0].endosok1,
      a_emision: this.detalleSeccionSiniestroComplemento.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSeccionSiniestroComplemento.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSeccionSiniestroComplemento.Siniestro[0].num_incisok,
      num_depend: this.detalleSeccionSiniestroComplemento.Siniestro[0].num_dependk,
      alarma: this.detalleSeccionSiniestroComplemento.Siniestro[0].alarma,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      modelo: this.detalleSeccionSiniestroComplemento.Siniestro[0].modelo,
      vehiculo: this.detalleSeccionSiniestroComplemento.Siniestro[0].vehiculo,
      responsable: this.detalleSeccionComplemento.Responsable,
      subCausa: this.detalleSeccionSiniestroComplemento?.Siniestro[0].sub_causa,
      serie: this.detalleSeccionSiniestroComplemento?.Siniestro[0].serie,
      kilometraje: this.detalleSeccionComplemento?.Kilometraje,
      Kilometraje: this.detalleSeccionSiniestroComplemento?.Siniestro[0].edad,
      edad: this.detalleSeccionSiniestroComplemento?.Siniestro[0].edad,
      tipoPerdida: this.detalleSeccionSiniestroComplemento?.Siniestro[0].serie_normal == 1 ? this.detalleSeccionSiniestroComplemento?.Siniestro[0].cve_perdida_total : 0,
      claveTipoPerdida: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_perdida_total,
      sexo: this.detalleSeccionSiniestroComplemento?.Siniestro[0].sexo,
      danosPreexistentes: this.detalleSeccionSiniestroComplemento?.Siniestro[0].serie_normal == 1 ? this.detalleSeccionSiniestroComplemento?.Siniestro[0].danos_preex == 0 ? 2 : 1 : 0,
      correoElectronico: this.detalleSeccionSiniestroComplemento?.Siniestro[0].email,
      estimacionDanos: 3, //REVIEW - ,
      cantidadDigitosIncorrectos: 0, //REVIEW
      status_mbs: this.detalleSeccionSiniestroComplemento.Siniestro[0].status_mbs,
      inicioFechaAtencion: this.detalleSeccionSiniestroComplemento?.Siniestro[0].feciniatn == fechaDefault ? this.detalleSeccionSiniestroComplemento?.Siniestro[0].fecaviso : this.detalleSeccionSiniestroComplemento?.Siniestro[0].feciniatn,
      inicioHoraAtencion: this.detalleSeccionSiniestroComplemento?.Siniestro[0].horainiatn == horaDefault ? 0 : this.detalleSeccionSiniestroComplemento?.Siniestro[0].horainiatn?.split(":")[0],
      finFechaAtencion: this.detalleSeccionSiniestroComplemento?.Siniestro[0].fecfinatn == fechaDefault ? this.detalleSeccionSiniestroComplemento?.Siniestro[0].fecaviso : this.detalleSeccionSiniestroComplemento?.Siniestro[0].fecfinatn,
      finHoraAtencion: this.detalleSeccionSiniestroComplemento?.Siniestro[0].horafinatn == horaDefault ? 0 : this.detalleSeccionSiniestroComplemento?.Siniestro[0].horafinatn?.split(":")[0],
      fechaAviso: this.detalleSeccionSiniestroComplemento.Siniestro[0].fecaviso,
      horaAviso: this.detalleSeccionSiniestroComplemento.Siniestro[0].horaviso,
      tipoUbicacion: this.detalleSeccionSiniestroComplemento?.Siniestro[0].tipo_ubicacion,
      perfilAdministrador: perfilAdministrador,
      serieAdministrador: this.detalleSeccionSiniestroComplemento.Siniestro[0].serie_admin,
      camposAdministrador: perfilAdministrador == 1 ? 1 : serieNormal,
      causa: this.detalleSeccionSiniestroComplemento.Siniestro[0].causa,
      pais: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].cve_pais,
      estado: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].cve_estado ?? 0,
      cp: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].cp || 0,
      colonia: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].colonia,
      municipio: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].cve_municipio,
      calle: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].referencias,
      referencias: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].referencias,
      fechaRegistro: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].fechareg || moment().format("dd/MM/yyyy"),
      tipoRobo: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].tipo_robo,
      fechaRobo: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].fecha_aviso_concepto == null ? this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].fecha_aviso : this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].fecha_aviso_concepto,
      participantes: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].num_participa,
      numeroActa: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].num_acta,
      ocra: this.detalleSeccionComplemento?.["ComplementoRobo"]?.[0].status_ocra == 1 ? true : false,
      fechaOcurrido: this.detalleSeccionSiniestroComplemento.Siniestro[0].fecsini,
      importe: this.detalleSeccionSiniestroComplemento?.Siniestro[0].serie_normal == 1 ? coberturas?.importe : null,
      cadenaCoberturas: `${this.procesosComunesService.generarCadenaCoberturasPagosComplemento([coberturas])}`,
      subUbicacion: this.detalleSeccionSiniestroComplemento?.Siniestro[0].sub_tipo_ubicacion,
      corralonDestino: this.detalleSeccionSiniestroComplemento?.Siniestro[0].corralon_destino
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.actualizaComplemento(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos del complemento.' }));
      },
    })
  }

  procesaCoberturas(): CoberturaProcesada {
    let Cobertura: CoberturaProcesada = { cveCobertura: 0, sumaAsegurada: 0, deducible: 0, importe: "", valida: false };

    if (this.detalleSeccionComplemento?.["Coberturas"] != undefined && this.detalleSeccionComplemento?.["Coberturas"]?.length) {
      Cobertura = { cveCobertura: this.detalleSeccionComplemento?.["Coberturas"][0].cve_coberturak, sumaAsegurada: this.detalleSeccionComplemento?.["Coberturas"][0].suma_aseg, deducible: this.detalleSeccionComplemento?.["Coberturas"][0].porc_deduc, importe: ((this.detalleSeccionComplemento?.["Coberturas"][0].estimado == null) ? ((this.detalleSeccionComplemento?.["Coberturas"][0].orden_servicio == 1) ? 0 : "") : this.detalleSeccionComplemento?.["Coberturas"][0].estimado), valida: true };
    }
    return Cobertura;
  }


  consultarComplementoWeb(siniestro: string) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(siniestro);
    const request = {
      sucursal: this.detalleSeccionSiniestroComplemento.Siniestro[0].sucursalk1,
      linea: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_linea,
      producto: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_prod,
      poliza: this.detalleSeccionSiniestroComplemento.Siniestro[0].polizak1,
      endoso: this.detalleSeccionSiniestroComplemento.Siniestro[0].endosok1,
      a_emision: this.detalleSeccionSiniestroComplemento.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSeccionSiniestroComplemento.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSeccionSiniestroComplemento.Siniestro[0].num_incisok,
      num_depend: this.detalleSeccionSiniestroComplemento.Siniestro[0].num_dependk,
      fechaSiniestro: this.detalleSeccionSiniestroComplemento.Siniestro[0].fecsini,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      causa: this.detalleSeccionSiniestroComplemento.Siniestro[0].causa,
      tiposTercero: '',
      cobertura: 1,
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaComplementoGeneral(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.detalleSeccionComplemento = value.Resultado;
        this.consultarPagosRecuperaciones(siniestro);
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos del complemento.' }));
      },
    })
  }

  procesaEventoPagosRecuperaciones(evento: { nombre: string, valor: any }) {
    if (evento.nombre == 'ACTUALIZA_COMPLEMENTO') {
      // this.actualizarComplemento();
      this.consultarPagosRecuperaciones(this.siniestroBase);
    }
    if (evento.nombre == 'ACTUALIZA_CONSULTA_TERCEROS') {
      this.consultarPagosRecuperaciones(this.siniestroBase);
    }
    if (evento.nombre == 'ACTUALIZA_TERCEROS') {
      this.guardarTercero(evento.valor);
      // this.consultarPagosRecuperaciones(this.siniestroBase);
    }
  }

  guardarTercero(tercero?: any) {
      const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.siniestroBase);
      const nombreLesionado = `${tercero.nombreLesionado ?? ''}|${tercero.apellidoPaterno ?? ''}|${tercero.apellidoMaterno ?? ''}`;
      const request = {
        sucursal: this.detalleSeccionSiniestroComplemento.Siniestro[0].sucursalk1,
        linea: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_linea,
        producto: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_prod,
        poliza: this.detalleSeccionSiniestroComplemento.Siniestro[0].polizak1,
        endoso: this.detalleSeccionSiniestroComplemento.Siniestro[0].endosok1,
        a_emision: this.detalleSeccionSiniestroComplemento.Siniestro[0].a_emisionk,
        no_reexpedicion: this.detalleSeccionSiniestroComplemento.Siniestro[0].no_reexpedicionk,
        cve_linea_ind: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_linea_indk,
        cve_secc_gpo: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_secc_gpok,
        inciso: this.detalleSeccionSiniestroComplemento.Siniestro[0].num_incisok,
        num_depend: this.detalleSeccionSiniestroComplemento.Siniestro[0].num_dependk,
        fechaSiniestro: this.detalleSeccionSiniestroComplemento.Siniestro[0].fecsini,
        moneda: siniestroFormateado.moneda,
        ramo: siniestroFormateado.ramo,
        sramo: siniestroFormateado.sramo,
        oficina: siniestroFormateado.oficina,
        consecutivo: siniestroFormateado.consecutivo,
        anio: siniestroFormateado.anio,
        tipoCliente: 2,
        id_lesionado: tercero?.id_lesionado ?? tercero?.terceroSeleccionado?.id_lesiona ??  undefined,
        nombre: nombreLesionado,
        edad: tercero.edad,
        id_tercero: tercero?.id_tercero ?? tercero.idTercero ?? 0,
        tipo: tercero?.tipo ?? undefined,
        importe: tercero?.importe ?? 0,
        numeroLiga: tercero?.num_liga ?? 0,
        proveedor: "",
        modulo: "R&P"
      }
      console.log(request)
      this.store.dispatch(ActivarLoadingAction());
      this.complementoWebService.guardaActualizaLesionado(request).subscribe({
        next: (value) => {
          this.store.dispatch(DesactivarLoadingAction());
          if (value.Resultado.IdLesionado && value.Exito) {
            this.procesosComunesService.alertaGeneralComplemento('Guardado', `La información se almacenó correctamente.`, 'success', false, true);
          } else {
            this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se pudo guardar o actualizar la información.`, 'info', false, true);
          }
          this.consultarPagosRecuperaciones(this.siniestroBase);
        },
        error: (err) => {
          this.store.dispatch(DesactivarLoadingAction());
          this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos procesar el guardado del lesionado' }));
        },
      })
  }

  validarRegistro(formulario, tipoCliente: number, responsable: number, estatusOcupante: number, estatusTercero: string, importe: string): boolean {
    // Validación 1: Tercero sin estatus válido
    if (tipoCliente == 2 && responsable == 2 && estatusOcupante != 3) {
      if (estatusTercero !== '5' && estatusTercero !== '6') {
        this.procesosComunesService.alertaGeneralComplemento(
          'Validación de Tercero',
          'No se puede Guardar/Actualizar el registro debido a que el responsable es el tercero y el tercero seleccionado no tiene estatus MP o JUEZ CÍVICO.',
          'warning',
          false,
          true
        );
        return false;
      }
    }

    // Validación 2: Importe no válido
    if (importe?.length) {
      const importeNumerico = parseFloat(importe.replace(/,/g, ''));
      if (importeNumerico <= 0) {
        this.procesosComunesService.alertaGeneralComplemento(
          'Validación de Importe',
          'No se puede guardar/actualizar debido a que el importe tiene que ser mayor a cero.',
          'warning',
          false,
          true
        );
        return false;
      }
    }

    // Validación 3: Tipo tercero no válido
    if (formulario.tipoTercero == null && tipoCliente === 2) {
      this.procesosComunesService.alertaGeneralComplemento(
        'Validación del tipo tercero',
        'No se puede guardar/actualizar debido a que el tipo tercero no ha sido seleccionado.',
        'warning',
        false,
        true
      );
      return false;
    }

    return true; // Todo correcto
  }
}
